import { render, staticRenderFns } from "./InformationAlvaraForm.vue?vue&type=template&id=4f49a4e3&scoped=true"
import script from "./InformationAlvaraForm.vue?vue&type=script&lang=js"
export * from "./InformationAlvaraForm.vue?vue&type=script&lang=js"
import style0 from "./InformationAlvaraForm.vue?vue&type=style&index=0&id=4f49a4e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f49a4e3",
  null
  
)

export default component.exports